exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main